import { deserialize, serialize, inheritSerialization } from "cerialize";
import BaseEntity from "../BaseEntity";
import TableColumn from "../TableColumn";
import { getVm } from "@/util/GlobalVm";

@inheritSerialization(BaseEntity)
export default class TUKBendaharaItemAccess extends BaseEntity {

    @serialize
    @deserialize
    public wilayah: string = "";

    @serialize
    @deserialize
    public bendahara_type: string = "";

    @serialize
    @deserialize
    public item_pembayaran_id: number = 0;

    @serialize
    @deserialize
    public item_name: string = "";

    @serialize
    @deserialize
    public description: string = "";

    public table(): any {
        return {
            item_name: this.item_name,
            wilayah: this.wilayah,
            bendahara_type: this.bendahara_type,
            description: this.description
        };
    }

    public static columnName(): Array<any> {
        const config = new TUKBendaharaItemAccess().table();
        let keys = Object.keys(config);

        return keys.map((field: any) => {
            const tableColumn = new TableColumn();
            tableColumn.name = getVm().$t(`label.${field}`);
            if (field === 'wilayah' || field === 'bendahara_type') {
                tableColumn.position = 'centered';
            }
            return tableColumn;
        });
    }
}
